import { lazy } from 'react';

const LoginPageConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/auth/login',
			component: lazy(() => import('./LoginPage'))
		}
	]
};

export default LoginPageConfig;
